export const PRODUCT_VALUE_PATTERN = /^\d{1,19}(\.\d{1,9})?$/;
//# sourceMappingURL=product-value-pattern.js.map